import { library } from "@fortawesome/fontawesome-svg-core";

/* import specific icons */
import {
  faHome,
  faBars,
  faMapLocationDot,
  faAt,
  faPhone,
  faHammer,
  faPersonDigging,
  faStairs,
  faRing,
  faTrowel,
  faSchoolCircleCheck,
  faHandshake,
  faBuilding
} from "@fortawesome/free-solid-svg-icons";

library.add(faHome, faBuilding, faBars, faMapLocationDot, faAt, faPhone, faHammer, faPersonDigging, faStairs, faRing, faTrowel, faSchoolCircleCheck, faHandshake);

export default library;
